// =============================================================================
// RECORRIDOS VIRTUALES 360° — configuración por propiedad
// -----------------------------------------------------------------------------
// Para sumar o cambiar un recorrido solo se edita este archivo:
// cada escena tiene { id, nombre, imagen (URL equirectangular 2:1), hotspots }
// y cada hotspot es una flecha { pitch, yaw, texto, destino } que lleva a otra
// escena. Para reemplazar una foto 360° por una real, basta cambiar la URL.
// =============================================================================

const ESCENAS_DEPTO = [
  {
    id: "living",
    nombre: "Living",
    imagen: "/recorridos/living.jpg",
    hotspots: [
      { pitch: -8, yaw: 40, texto: "Ir a Cocina", destino: "cocina" },
      { pitch: -8, yaw: -70, texto: "Ir a Dormitorio", destino: "dormitorio" },
    ],
  },
  {
    id: "cocina",
    nombre: "Cocina",
    imagen: "/recorridos/cocina.jpg",
    hotspots: [
      { pitch: -8, yaw: -40, texto: "Ir a Living", destino: "living" },
      { pitch: -8, yaw: 120, texto: "Ir a Baño", destino: "bano" },
    ],
  },
  {
    id: "dormitorio",
    nombre: "Dormitorio",
    imagen: "/recorridos/dormitorio.jpg",
    hotspots: [{ pitch: -8, yaw: 90, texto: "Ir a Living", destino: "living" }],
  },
  {
    id: "bano",
    nombre: "Baño",
    imagen: "/recorridos/bano.jpg",
    hotspots: [{ pitch: -8, yaw: 0, texto: "Ir a Cocina", destino: "cocina" }],
  },
];

// Recorrido habilitado solo en 2 propiedades de la demo (es un extra)
export const RECORRIDOS = {
  "prop-1": { escenas: ESCENAS_DEPTO },
  "prop-2": {
    escenas: ESCENAS_DEPTO.map((e) => ({
      ...e,
      hotspots: e.hotspots.map((h) => ({ ...h, yaw: -h.yaw })),
    })),
  },
};

export function tieneRecorrido(propiedadId) {
  return !!RECORRIDOS[propiedadId];
}
